import {useState} from 'react';

import {useUserDetails} from '@/lib/auth';

import {useRequiresNameConfirmation} from '../hooks';
import {WelcomeModal} from '../modals';

import type {FC} from 'react';

export interface RequiredProfileGateProps {
  isGuest?: boolean;
}

/** Blocks the app behind a non-dismissible welcome modal until the user has saved their name once. */
export const RequiredProfileGate: FC<RequiredProfileGateProps> = ({isGuest}) => {
  const {user} = useUserDetails();
  const {profile, isRequired} = useRequiresNameConfirmation();
  // Mount on first open only, but stay mounted after so the save still gets its close animation.
  const [hasOpened, setHasOpened] = useState(false);
  if (isRequired && !hasOpened) setHasOpened(true);

  if (!hasOpened) return null;

  return (
    <WelcomeModal isOpen={isRequired} profile={profile} avatarSeed={user?.sub} isGuest={isGuest} />
  );
};
